// extracted by mini-css-extract-plugin
export var bodySections = "_co-8";
export var gray = "_co-7";
export var green = "_co-4";
export var iconContainer = "_co-9";
export var iconWidgetContainer = "_co-1";
export var phoneIcon = "_co-2";
export var red = "_co-5";
export var statusDot = "_co-3";
export var widgetContainer = "_co-0";
export var yellow = "_co-6";